export const getMetaFlight = (store) => store.metaFlightDetails.flight;
export const getMetaFlightDetailsFetchStatus = (state) => state.metaFlightDetails.fetchStatus;
export const getMetaFlightDetailsSlice = (state) => state.metaFlightDetails;
